import type { ContactUsConfig, ContactUsTexts } from './types'
import { commonTexts } from './common'
import { theme as brandTheme } from '@/config/brands'
import { t } from '@/i18n/utils'

/**
 * NovelMello 品牌 Contact Us 页面配置
 * 设计：浅底 #FBF6FB + 白卡表单（描边 #F0E6F2）+ 粉紫渐变胶囊按钮
 *
 * 注意：文案必须用 getter 逐项透传 commonTexts，不能用展开运算符 —— 展开会立即
 * 触发 getter，导致 t() 在 i18n 初始化前求值、切换语言后文案不更新。
 */
const novelmelloTexts: ContactUsTexts = {
  get feedbackTitle() { return commonTexts.feedbackTitle },
  get feedbackPlaceholder() { return commonTexts.feedbackPlaceholder },
  get emailTitle() { return commonTexts.emailTitle },
  get emailPlaceholder() { return commonTexts.emailPlaceholder },
  get submitButton() { return commonTexts.submitButton },
  get submittingButton() { return commonTexts.submittingButton },
  get successToast() { return commonTexts.successToast },
  get failToast() { return commonTexts.failToast },
  get emailErrorToast() { return commonTexts.emailErrorToast },
  // 顶栏标题，复用既有公共词条（en: "Contact us"）
  get pageTitle() { return t('ContactUs') },
}

export const contactUsConfig: ContactUsConfig = {
  texts: novelmelloTexts,
  colors: {
    // 页面底色 #FBF6FB
    bgPrimary: brandTheme.bgGlobal,
    // 输入控件底色（白卡）
    bgTertiary: brandTheme.bgCard,
    // ink-1 #2B1B34
    textPrimary: brandTheme.textPrimary,
    // ink-3 #AB9BB8
    textTertiary: brandTheme.textTertiary,
    textPlaceholder: brandTheme.textTertiary,
    // 必填星号 = 主色粉 #F0509B
    accentRed: brandTheme.primaryColor,
    primaryColor: brandTheme.primaryColor,
    whiteColor: brandTheme.textInverse,
    // —— NovelMello 页面级细节 ——
    cardBg: brandTheme.bgCard,
    // 输入框描边为页面级规格 #F0E6F2，与品牌分割线色 borderPrimary(#F2EAF4) 不同，故写死
    borderColor: '#F0E6F2',
    submitGradient: brandTheme.primaryGradient || 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)',
    submitShadow: '0 8px 20px rgba(240, 80, 155, 0.25)',
  },
}
